/**
 * Status tone and colors matching MTRCB Mobile App & HRIS-MVP standards.
 * Never rely solely on color; combines text with colored dot badge and soft tint background.
 */
export type StatusTone = "success" | "warning" | "error" | "info" | "neutral" | "brand";

export const statusColors: Record<StatusTone, { fg: string; bg: string }> = {
  success: { fg: "#00934C", bg: "#E6F4EA" }, // MTRCB Green
  warning: { fg: "#D97706", bg: "#FEF3C7" }, // Amber
  error: { fg: "#D1222B", bg: "#FEE2E2" },   // MTRCB Red
  info: { fg: "#0072BC", bg: "#E0F2FE" },    // MTRCB Brand Blue
  neutral: { fg: "#475569", bg: "#F1F5F9" }, // Slate
  brand: { fg: "#0072BC", bg: "#EBF5FB" },
};

/** Normalizes backend review / ticket statuses to standard StatusTone */
export function getStatusTone(status?: string): StatusTone {
  if (!status) return "neutral";
  const s = status.toUpperCase();
  if (s === "ACKNOWLEDGED" || s === "VERIFIED" || s === "COMPLIANT" || s === "ACTIVE" || s === "CLAIMED") {
    return "success";
  }
  if (s === "PENDING" || s === "IN_REVIEW" || s === "UNCLAIMED") {
    return "info";
  }
  if (s === "DUPLICATE" || s === "EXPIRED") {
    return "warning";
  }
  if (s === "REJECTED" || s === "WITH_VIOLATION" || s === "NON_COMPLIANT" || s === "BLOCKED") {
    return "error";
  }
  return "neutral";
}
